import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {HttpCommonService} from "../../services/http-common.service";
import {ShortMessageService} from "../../services/short-message.service";
import {mobileValidator, loginUserNameValidator} from "../../validators/validators";
import {GlobalService} from "../../services/global.service";
import {NzMessageService, NzModalService, NzModalSubject} from "ng-zorro-antd";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {CaptchaService} from "../../services/captcha.service";

declare var initGeetest: any;
import * as CryptoJS from 'crypto-js';

@Component({
  selector: 'app-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.css']
})
export class LoginModalComponent implements OnInit, OnDestroy {
  userNotExist = false;//用户名或密码是否存在
  phoneNotExist = false;//手机号码是否存在
  formModel: FormGroup;
  formEnterpriseModel: FormGroup;
  public userType = 1;//个人企业登录切换
  public loginType = 1;//密码验证码登录切换
  //登录按钮
  public btnText: string;
  public btnFlag: boolean;
  //验证码
  public sum: number;
  public timer: any;
  //控制头部tab页
  selectIndex = 0;

  // 验证码
  captcha: string;

  // 统计密码错误次数
  // public times = 0;

  @Input()
  prevUrl: any;//登录前的url
  @Input()
  prevParams: any;//登录前的url的参数
  @Input()
  isPersonLogin: string = '1';

  _isLoading = false; //个人登录
  _isLoading2 = false; // 企业登录

  constructor(fb: FormBuilder, public httpService: HttpCommonService, private router: Router,
              private routerInfo: ActivatedRoute, private showMsg: NzMessageService,
              private globalService: GlobalService, private showAlert: NzModalService,
              private sms: ShortMessageService,
              public captchaService: CaptchaService, private subject: NzModalSubject) {
    //控制头部tab页
    this.selectIndex = 0;
    if (this.routerInfo.snapshot.queryParams["selectIndex"] != null) {
      this.selectIndex = this.routerInfo.snapshot.queryParams["selectIndex"];
      if (this.selectIndex == 0) {
        this.userType = 1;
      } else {
        this.userType = 2;
      }
    }
    this.prevUrl = this.routerInfo.snapshot.queryParams['url'];
    this.prevParams = this.routerInfo.snapshot.queryParams['params'];
    //个人验证
    this.formModel = fb.group({
      userName: ['', [Validators.required, loginUserNameValidator]],
      mobile: ['', [Validators.required, mobileValidator]],
      password: ['', [Validators.required]],
      code: ['', [Validators.required]],
      captcha: ['', [Validators.required]],
    });
    //企业验证
    this.formEnterpriseModel = fb.group({
      enterpriseName: ['', [Validators.required]],
      enterprisePwd: ['', [Validators.required]],
      captcha: ['', [Validators.required]],
    });
    this.btnText = "会员登录";
    this.btnFlag = false;

    this.sum = 61;

    this.captcha = this.captchaService.generateCaptcha();
  }

  ngOnDestroy() {
    this.subject.destroy('onCancel');
  }

  ngOnInit() {
    /*this.captchaPersonnel();
    this.captchaEnterprise();*/
    this.userType = this.isPersonLogin == '1' ? 1 : 2;
  }

  checkUserName() {
    console.log(this.formModel.get('userName').value);
    this.httpService.get('/user/center/xhsRest/phoneOrUserNameExist', {phoneOrUserName: this.formModel.get('userName').value})
      .subscribe(data => {
        console.log(data);
        if (data.stateCode == '20105') {//用户名不存在
          this.userNotExist = true;
        } else {
          this.userNotExist = false;
        }
      });
  }

  checkPhone() {
    this.httpService.get('/user/center/xhsRest/phoneExist',
      {
        phone: this.formModel.get('mobile').value,
        captcha: this.formModel.get("captcha").value,
        jessionID: this.globalService.getValue("JessionID"),
        type: "1",
        delCaptcha: "1"
      })
      .subscribe(data => {
        console.log(data);
        if (data.stateCode == '20119') {//手机号不存在
          this.showAlert.error({content: '该用户不存在，请检查手机号码是否正确！', width: '300px', okText: '确认'});
          /*clearInterval(this.timer);
           this.sum = 61;*/
        } else if (data.stateCode == '20115') { // 验证码错误
          this.showAlert.error({content: '图形验证码错误，请重新输入！', width: '300px', okText: '确认'});
          this.captchaService.changeCap();
          /* clearInterval(this.timer);
           this.sum = 61;*/
        } else {
          this.sendMsg();
        }
      });

  }

  /**
   * 切换验证码登录
   */
  loginTypeChange() {
    if (this.loginType == 1) {
      this.loginType = 2;
    } else {
      this.loginType = 1;
    }
    this.formModel.reset();
    this.captchaService.changeCap();
  }

  //极验-个人
  captchaPersonnel() {
    let thiss = this;
    var handlerEmbed = function (captchaObj) {
      $("#login-submit").click(function (e) {
        var validate = captchaObj.getValidate();
        if (!validate) {
          $("#notice")[0].className = "show";
          setTimeout(function () {
            $("#notice")[0].className = "hide";
          }, 3000);
          e.preventDefault();
        } else {
          //thiss.loginUser();
        }
      });
      // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
      captchaObj.appendTo("#embed-captcha");
      captchaObj.onReady(function () {
        $("#wait")[0].className = "hide";
      });
      //验证通过--直接登录
      /*captchaObj.onSuccess(function () {
       thiss.loginUser();
       });*/
      // 更多接口参考：http://www.geetest.com/install/sections/idx-client-sdk.html
    };
    thiss.httpService.get("/user/center/xhsRest/pc_geetest_register?t=" + (new Date()).getTime()).subscribe(data => {
      initGeetest({
        gt: data.gt,
        width: '100%',
        challenge: data.challenge,
        product: "float", // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
        offline: !data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
        // 更多配置参数请参见：http://www.geetest.com/install/sections/idx-client-sdk.html#config
      }, handlerEmbed);
    });
  }

  //极验-企业
  captchaEnterprise() {
    let enterThis = this;
    var handlerEmbed = function (captchaObj) {
      $("#enterpriseSubmit").click(function (e) {
        var validate = captchaObj.getValidate();
        if (!validate) {
          $("#notice-enterprise")[0].className = "show";
          setTimeout(function () {
            $("#notice-enterprise")[0].className = "hide";
          }, 3000);
          e.preventDefault();
        } else {
          //enterThis.loginEnterpriseUser();
        }
      });
      // 将验证码加到id为captcha的元素里，同时会有三个input的值：geetest_challenge, geetest_validate, geetest_seccode
      captchaObj.appendTo("#embed-captcha-enterprise");
      captchaObj.onReady(function () {
        $("#wait-enterprise")[0].className = "hide";
      });
      //验证通过--直接登录
      /*captchaObj.onSuccess(function () {
       thiss.loginUser();
       });*/
      // 更多接口参考：http://www.geetest.com/install/sections/idx-client-sdk.html
    };
    enterThis.httpService.get("/user/center/xhsRest/pc_geetest_register?t=" + (new Date()).getTime()).subscribe(data => {
      initGeetest({
        gt: data.gt,
        width: '100%',
        challenge: data.challenge,
        product: "float", // 产品形式，包括：float，embed，popup。注意只对PC版验证码有效
        offline: !data.success // 表示用户后台检测极验服务器是否宕机，一般不需要关注
        // 更多配置参数请参见：http://www.geetest.com/install/sections/idx-client-sdk.html#config
      }, handlerEmbed);
    });


  }

  /**
   * 发送短信
   */
  sendMsg(): any {
    // if(this.phoneNotExist){
    //   return false;
    // }

    this.sum = 60;
    this.timer = setInterval(() => {
      this.sum--;
      if (this.sum < 1) {
        clearInterval(this.timer);
        this.sum = 61;
      }
    }, 1000);
    let thiss = this;

    this.sms.send2(this.formModel.get("mobile").value, "个人用户登录身份验证",
      this.formModel.get("captcha").value, this.globalService.getValue("JessionID"), "1", "1").subscribe(result => {
      // console.log(result);
      if (result.stateCode == "00001") {
        //thiss.showMsg.success("发送成功，请注意查收信息");
      } else if (result.stateCode == "00002") {
        //thiss.showMsg.error("信息发送失败，请重新发送");
        this.showAlert.error({content: '信息发送失败，请重新发送！', width: '300px', okText: '确认'});
        clearInterval(thiss.timer);
        thiss.sum = 61;
      } else if (result.stateCode == "00005") {
        // 获取短信验证码受限，访问次数达到上限
        this.showAlert.error({
          content: '获取短信验证码受限，由于您今日请求次数已达上限，请明日再试。如需紧急帮助，可联系客服，客服电话：010-88052705。',
          width: '400px',
          okText: '确认'
        });
        clearInterval(thiss.timer);
        thiss.sum = 61;
      } else {
        this.showAlert.error({content: '图形验证码错误，请重新输入！', width: '300px', okText: '确认'});
        clearInterval(thiss.timer);
        thiss.sum = 61;
        this.captchaService.changeCap();
      }
    });

  }

  //
  cancel(event) {
    if (event == '1') {//企业用户忘记密码
      this.subject.destroy('onCancel');
    } else if (event == '2') {//企业入驻
      this.subject.destroy('onCancel');
    } else if (event == '3') {//个人用户登录
      this.loginUser();

    } else if (event == '4') {//企业用户登录
      this.loginEnterpriseUser();
    } else if (event == '5') {//个人用户忘记密码
      this.subject.destroy('onCancel');
    } else if (event == '6') {//个人用户注册
      this.subject.destroy('onCancel');
    }

  }

  /**
   * 个人用户登录
   */
  loginUser() {
    // console.log(this.prevUrl + "?" + this.prevParams);
    let validate = true;
    let userName = true;

    if (this.loginType == 1) {//密码登录
      if (this.userNotExist) {
        return;
      }
      if (!this.formModel.get("userName").valid) {
        this.formModel.get("userName").markAsDirty();
        return;
      }
      if (!this.formModel.get("password").valid) {
        this.formModel.get("password").markAsDirty();
        return;
      }
      if (!this.formModel.get("captcha").valid) {
        this.formModel.get("captcha").markAsDirty();
        return;
      }
      userName = this.formModel.get("userName").value;
      validate = this.formModel.get("userName").valid && this.formModel.get("password").valid;
    } else {//验证码登录
      if (!this.formModel.get("mobile").valid) {
        this.formModel.get("mobile").markAsDirty();
        return;
      }
      if (!this.formModel.get("captcha").valid) {
        this.formModel.get("captcha").markAsDirty();
        return;
      }
      if (!this.formModel.get("code").valid) {
        this.formModel.get("code").markAsDirty();
        return;
      }
      userName = this.formModel.get("mobile").value;
      validate = this.formModel.get("mobile").valid && this.formModel.get("code").valid;
    }
    if (validate) {//验证通过时
      this._isLoading = true;
      this.btnText = "正在登录...";
      this.btnFlag = true;

      this.httpService.post("/auth/jwt/token", {
        userName: userName,
        userType: 'person',
        password: CryptoJS.MD5(this.formModel.get("password").value).toString(),
        isMessage: this.loginType == 1 ? 0 : 1,
        code: this.formModel.get("code").value,
        captcha: this.formModel.get("captcha").value,
        jessionID: this.globalService.getValue("JessionID")
      }).subscribe(result => {

        // 设置未读消息不显示
        this.globalService.setKey("countShow", true);

        // console.log(result)
        var responseSuc = false;
        if (result.stateCode == '20101') {

          responseSuc = true;
          // this.showMsg.success("登录成功");
          this.globalService.setLoginState(true);
          this.subject.destroy('');
          window.location.reload();
          let userInfo = {};
          if (result.data.userName) {
            userInfo['_userName'] = result.data.userName;
          }

          if (result.data.userId) {
            userInfo['_userId'] = result.data.userId;
          }

          if (result.data.roles != null && result.data.roles.length > 0) {
            userInfo['_role'] = result.data.roles[0].roleName;
          }

          if (result.data.userType) {
            userInfo['_userType'] = result.data.userType;
            this.globalService.userType = result.data.userType;
          }

          // result.data.loginType 是否是首次登陆，首次登陆状态为0，否则为1

          this.globalService.setUserInfo(JSON.stringify(userInfo));

          if (this.prevUrl != null && this.prevUrl != '') {
            this.router.navigate([this.prevUrl], {queryParams: this.prevParams});
          } else {

          }
        } else if (result.stateCode == '20102') {
          //this.showMsg.error("手机号码为空");
          this.showAlert.error({content: '手机号码不能为空！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20103') {
          // this.showMsg.error("密码为空");
          this.showAlert.error({content: '密码不能为空！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20104') {
          // this.showMsg.error("用户类型为空");
          this.showAlert.error({content: '用户类型不能为空！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20105') {
          // this.showMsg.error("用户不存在");
          if (this.loginType == 1) { // 密码登录
            this.showAlert.error({content: '该用户不存在，请检查用户名/手机号码是否正确！', width: '300px', okText: '确认'});
          } else {
            this.showAlert.error({content: '该用户不存在，请检查手机号码是否正确！', width: '300px', okText: '确认'});
          }
        } else if (result.stateCode == '20106') {
          // this.showMsg.error("密码错误");

          // this.times += 1;
          // this.showAlert.error({content: '密码错误' + this.times + '次，5次后账号将被临时冻结。', okText: '确认'});
          this.showAlert.error({content: '用户名或密码错误，请重新输入！', okText: '确认'});

          // 清空输入框的密码
          this.formModel.get('password').reset();
        } else if (result.stateCode == '20114') {
          // 重置错误次数
          // this.times = 0;

          // 密码错误5次后，冻结10分钟
          this.showAlert.error({
            content: '您已输错5次，账号已被临时冻结10分钟。是否需要重置密码？',
            okText: '立即重置',
            onOk: () => {
              this.router.navigate(["/comLR/findPwd"]);
            },
            cancelText: '稍后再试',
            onCancel: () => {
              // 清空输入框的密码
              this.formModel.get('password').reset();
            }
          });
        } else if (result.stateCode == '20107') {
          // this.showMsg.error("验证码错误或为空");
          this.showAlert.error({content: '短信验证码错误，请重新输入！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20108') {
          // this.showMsg.error("token为空");
          this.showAlert.error({content: 'token为空！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '00003') {
          // this.showMsg.error("验证码超时");
          this.showAlert.error({content: '短信验证码超时，请重新获取！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20113') {
          this.showAlert.error({content: '您的登录账号目前已被禁用，请联系客服咨询详细情况！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20115') {
          //this.showMsg.error("手机号码为空");
          this.showAlert.error({content: '图形验证码错误，请重新输入！', width: '300px', okText: '确认'});
        } else {
          // this.showMsg.error("其他未知错误");
          this.showAlert.error({content: '系统错误，请稍后再试！', width: '300px', okText: '确认'});
        }

        if (!responseSuc) {
          this._isLoading = false;
          this.captchaService.changeCap();
          $("#embed-captcha").html("");
          //this.captchaPersonnel();
          return;
        }
      });

      this.btnText = "会员登录";
      this.btnFlag = false;
    }
  }

  /**
   * 企业登录
   */
  loginEnterpriseUser() {
    if (!this.formEnterpriseModel.get("enterpriseName").valid) {
      this.formEnterpriseModel.get("enterpriseName").markAsDirty();
      return;
    }
    if (!this.formEnterpriseModel.get("enterprisePwd").valid) {
      this.formEnterpriseModel.get("enterprisePwd").markAsDirty();
      return;
    }
    if (!this.formEnterpriseModel.get("captcha").valid) {
      this.formEnterpriseModel.get("captcha").markAsDirty();
      return;
    }
    if (this.formEnterpriseModel.valid) {//验证通过时
      this._isLoading2 = true;
      this.btnText = "正在登录...";
      this.btnFlag = true;

      this.httpService.post("/auth/jwt/token", {
        userName: this.formEnterpriseModel.get("enterpriseName").value,
        userType: 'enterprise',
        password: CryptoJS.MD5(this.formEnterpriseModel.get("enterprisePwd").value).toString(),
        captcha: this.formEnterpriseModel.get("captcha").value,
        jessionID: this.globalService.getValue("JessionID")
      }).subscribe(result => {
        var responseSuc = false;
        if (result.stateCode == '20101') {

          // 设置未读消息不显示
          this.globalService.setKey("countShow", true);

          responseSuc = true;
          // this.showMsg.success("登录成功");
          this.globalService.setLoginState(true);
          this.subject.destroy('');
          window.location.reload();
          let userInfo = {};
          if (result.data.userName) {
            userInfo['_userName'] = result.data.userName;
          }

          if (result.data.userId) {
            userInfo['_userId'] = result.data.userId;
          }

          if (result.data.roles != null && result.data.roles.length > 0) {
            userInfo['_role'] = result.data.roles[0].roleName;
          }

          if (result.data.userType) {
            userInfo['_userType'] = result.data.userType;
            this.globalService.userType = result.data.userType;
          }

          if (result.data.companyId) {
            userInfo['_companyId'] = result.data.companyId;
          }

          if (result.data.companyName) {
            userInfo['_companyName'] = result.data.companyName;
          }

          if (result.data.pType) {
            userInfo['_pType'] = result.data.pType;
          }

          // result.data.loginType 是否是首次登陆，首次登陆状态为0，否则为1

          this.globalService.setUserInfo(JSON.stringify(userInfo));

          //判断首次登陆状态
          if (result.data.loginType == "0" || result.data.loginType == null || result.data.loginType == "") {
            this.showAlert.success({
              content: '欢迎您进入新华信用平台，前往企业中心，完善企业资料可更好的享受平台服务',
              cancelText: '暂不设置',
              onCancel: () => {
                this.router.navigateByUrl("/");
              },
              okText: '立即前往',
              onOk: () => {
                this.router.navigateByUrl("/MemberCenterParent/EnterpInfoParent/MbcenterEnterpInfo");
              },
            });
          } else {
            if (this.prevUrl != null && this.prevUrl != '') {
              this.router.navigate([this.prevUrl], {queryParams: this.prevParams});
            } else {
            }
          }
        } else if (result.stateCode == '20102') {
          // this.showMsg.error("企业账号为空");
          this.showAlert.error({content: '企业账号不能为空！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20103') {
          // this.showMsg.error("密码为空");
          this.showAlert.error({content: '密码不能为空！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20104') {
          // this.showMsg.error("用户类型为空");
          this.showAlert.error({content: '用户类型不能为空！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20105') {
          // this.showMsg.error("用户不存在");
          this.showAlert.error({content: '您登录的用户不存在', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20106') {
          // this.showMsg.error("密码错误");
          this.showAlert.error({content: '您输入的密码错误，请重新输入', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20108') {
          // this.showMsg.error("token为空");
          this.showAlert.error({content: 'token为空！', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20113') {
          this.showAlert.error({content: '您的登录账号目前已被禁用，请联系客服咨询详细情况', width: '300px', okText: '确认'});
        } else if (result.stateCode == '20115') {
          //this.showMsg.error("手机号码为空");
          this.showAlert.error({content: '图形验证码错误，请重新输入！', width: '300px', okText: '确认'});
        } else {
          // this.showMsg.error("其他未知错误");
          this.showAlert.error({content: '系统错误，请稍后再试！', width: '300px', okText: '确认'});
        }

        if (!responseSuc) {
          this._isLoading2 = false;
          this.captchaService.changeCap();
          $("#embed-captcha-enterprise").html("");
          //this.captchaEnterprise();
          return;
        }
      });

      this.btnText = "会员登录";
      this.btnFlag = false;
    }
  }


  /*
   * 个人用户重置表单
   */
  resetFormP() {
    // alert('个人')
    this.formModel.reset();
    this.captchaService.changeCap();
  }


  /*
   * 企业用户重置表单
   */
  resetFormB() {
    // alert('企业')
    this.formEnterpriseModel.reset();
    this.captchaService.changeCap();
  }

}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/components/login-modal/login-modal.component.ts